import { Grid } from "@mui/material";
import React from "react";

export default function UnAuthorized() {
    return (
        <div className="mt-3">
            <Grid container >
                <Grid item sm={12} align={"center"}>
                    <h2 align={"center"} style={{color: '#0A456D'}}>Merchant is not enabled for Pay-By-Link. Please contact support if you require this feature.</h2>
                </Grid>
            </Grid>
        </div>
    );
}
